import { http } from 'services';

export function getPersonInvitationPreAccept(type, query, cbSuccess, cbError) {
  http.get(
    `auth/${type}/pre-accept-invitation`,
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function personAcceptInvitation(type, payload, cbSuccess, cbError) {
  http.post(
    `auth/${type}/accept-invitation`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-authentication/api-auth-invitation.js